const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
  // iStyle constants
  insuranceUpdate: "insurance-update",
  variantCTOChange: "variant-cto-change",
  flipCheckoutSubmit: "flip-checkout-submit",
};
